import StyleSettingsCarouselUploader from 'components/StyleSettingsCarouselUploader/StyleSettingsCarouselUploader';
import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { TLanguageIDs, ICustomGroups } from 'types';
import { IStyleContext, StyleContext } from '../../../styleState/styleContext';
import NormalDisplay from './components/NormalDisplay';
import LoaderWithProps from 'components/Loader/LoaderWithProps';
import style from './MediaGroup.module.scss';

interface IMediaGroup {
	data: ICustomGroups;
	languageId: TLanguageIDs;
}

const MediaGroup: React.FC<IMediaGroup> = ({ data, languageId }) => {
	const {
		deleteMediaSettingsToCarousel,
		addMediaSettingsToCarousel,
		addGroupForLoader,
		removeGroupForLoader,
		replacePdfToCarousel,
		setMediaSettingsFromNormalDisplay,
		changeTypeOfModalWindow,
		selectedGroup,
		selectedLanguage,
		groupsForLoader,
		useCustomerSettings,
	} = useContext<IStyleContext>(StyleContext);
	const headingElement = useRef<null | HTMLDivElement>(null);

	const groupLoading = groupsForLoader.some((el) => el === data.id);
	const isMakeImageRequest = selectedLanguage === languageId;

	useEffect(() => {
		if (selectedGroup?.id === data.id && selectedLanguage === languageId) {
			headingElement.current?.scrollIntoView({ behavior: 'smooth' });
		}
	}, [selectedGroup]);

	const showGroupLoader = () => {
		addGroupForLoader(data.id);
	};

	const hideGroupLoader = () => {
		removeGroupForLoader(data.id);
	};

	const handlePDFMenuSizeError = () => {
		changeTypeOfModalWindow('PDFMenuSizeExceeded');
	};

	const displayType = () => {
		if (data.isMultipleItems) {
			return (
				<StyleSettingsCarouselUploader
					group={data}
					languageId={languageId}
					selectedLanguage={selectedLanguage}
					deleteHandler={deleteMediaSettingsToCarousel}
					addItemHandler={addMediaSettingsToCarousel}
					showGroupLoader={showGroupLoader}
					hideGroupLoader={hideGroupLoader}
					replacePdfToCarousel={replacePdfToCarousel}
					isDisabledControls={useCustomerSettings}
				/>
			);
		}
		return (
			<NormalDisplay
				group={data}
				languageId={languageId}
				isDisabledControls={useCustomerSettings}
				showGroupLoader={showGroupLoader}
				hideGroupLoader={hideGroupLoader}
				onPDFMenuSizeError={handlePDFMenuSizeError}
				setMediaSettingsFromNormalDisplay={setMediaSettingsFromNormalDisplay}
				groupLoading={groupLoading}
				isMakeImageRequest={isMakeImageRequest}
			/>
		);
	};

	return (
		<div className={style.container} ref={headingElement} data-test={`MediaField-${data.key}`}>
			<Text
				translationNameSpace="mediaSettings"
				translationKey={data.key}
				theme="secondary"
				size="l"
				weight="bold"
			/>
			{displayType()}
			{groupLoading ? (
				<div className={style.loader}>
					<LoaderWithProps loaderSize="big" />
				</div>
			) : null}
		</div>
	);
};

export default MediaGroup;
